import { useMemo, useRef } from 'preact/hooks';
import { useAuth } from './auth';

/**
 * Adapter that hands the lazy `{ getToken, hydrate }` shape our API helpers
 * expect. Reading the token through a ref means authedFetch's 401-retry picks
 * up a freshly-hydrated token rather than a stale closure value.
 */
export function useApiAuth() {
  const { accessToken, hydrate } = useAuth();
  const ref = useRef<string | null>(accessToken);
  ref.current = accessToken;
  return useMemo(() => ({ getToken: () => ref.current, hydrate }), [hydrate]);
}
